(function () {

  // Detectar dispositivo táctil (móvil/tablet)
  if ('ontouchstart' in window || navigator.maxTouchPoints > 0) return;

  const eliminar = () => {
    document.querySelectorAll('li a[href="http://profesional.pshcosmetics.com/"]').forEach(a => {
      a.closest("li")?.remove();
    });
  };

  new MutationObserver(eliminar).observe(document.documentElement, {
    childList: true,
    subtree: true
  });

})();
